import styled, { css } from 'styled-components';

export const ButtonOrderBy = styled.button`
  ${({ isActive, isError }) => css`
    border: none;
    background: transparent;
    ${isActive &&
      css`
        svg {
          color: ${isError ? '#cc0000' : '#74a50a'} !important;
        }
      `};
  `}
`;
